import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import Head from "next/head";
import createAccountContent from "@/translations/createAccountContent";
import NextLink from "next/link";
import {
  Flex,
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Stack,
  FormHelperText,
  IconButton,
  InputGroup,
  InputRightElement,
  Img,
} from "@chakra-ui/react";
import { Typography } from "@material-tailwind/react";
// import { EyeIcon, EyeSlashIcon } from "chakra-ui-ionicons";
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import useCustomToast from "hooks/useCustomToast";
import StarEle from "@/utils/StarElement";
import Spinner from "@/components/Spinner";
import { login, userLogout } from "store/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "@/lib/auth";
const Login = () => {
  const toast = useCustomToast();
  const { locale } = useRouter();
  const router = useRouter();
  const dispatch = useDispatch();
  const { authenticateWithToken } = useAuth();
  const authState = useSelector((state) => state.auth);
  const { loading } = authState;
  const { email, pass } = createAccountContent[locale];
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [emailError, setEmailError] = useState(null);
  const [passwordError, setPasswordError] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [show, setShow] = useState(false);
  const [IsLoading, setIsLoading] = useState(loading);
  const handleClickPass = () => setShow(!show);
  const [Error, setError] = useState(null);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name == "password") {
      setFormData({ ...formData, [name]: value.trim("") });
    } else {
      setFormData({ ...formData, [name]: value });
    }
    // Validate email
    if (name === "email") {
      const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
      if (!value || value == "") {
        setEmailError("Email is required");
      } else if (!emailPattern.test(value)) {
        setEmailError("Email is invalid");
      } else {
        setEmailError(null);
      }
    }

    if (name === "password") {
      if (!value || value == "") {
        setPasswordError("Password is required");
      } else {
        setPasswordError(null);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

    if (!formData.email) {
      setEmailError("Email is required");
    } else if (!emailPattern.test(formData.email)) {
      setEmailError("Email is invalid");
    } else {
      setEmailError(null);
    }

    if (!formData.password) {
      setPasswordError("Password is required");
    } else {
      setPasswordError(null);
    }

    if (formData.email != "" && formData.password != "") {

      try {
        const resultAction = await dispatch(
          login({ email: formData.email, password: formData.password })
        );
        if (resultAction?.payload?.two_factor_auth) {
          localStorage.setItem("otp_email", resultAction?.payload?.email);
          router.push("/otp-varification");
        }
        else {
          if (login.fulfilled.match(resultAction)) {
            if (resultAction.payload?.success && resultAction.payload?.data?.is_activated === true) {
              try {
                await authenticateWithToken(resultAction.payload.data.customToken);
                toast("Successfully logged-in user!", "success", "", true);
                router.push("/dashboard");
              } catch (authError) {
                toast("Authentication failed after login", "error", "", true);
                setIsLoading(false);
              }
            } else {
              toast(
                "Account is not activated!",
                "error",
                "",
                true
              );
              userLogout(dispatch, router);
              setIsLoading(false);
            }

          } else {
            toast((resultAction.payload || 'Login failed'), 'error', "", true);
            setIsLoading(false);
          }
        }
      } catch (error) {
        const errorMessage = error.message;
        setError(errorMessage);
        setIsLoading(false);
      }
    }
  };
  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  return (
    <Flex
      className="login-main-Box-wrap"
      as="main"
      w={["100%", "100%", "100%", "100%"]}
    >
      <Box className="container mx-auto">
        {IsLoading && <Spinner />}
        <Box className="login-page-container">
          <Box className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">
            <Box className="login-form-wrapper">
              <Head>
                <title>Skilsoar</title>
              </Head>
              <h1 className="heading-color login-heading-wrap text-center mb-[30px]">
                Welcome to Login
              </h1>
              <form className="authform" onSubmit={handleSubmit}>
                <Stack spacing={3}>
                  <Stack spacing={2}>
                    <FormControl className="mb-4">
                      <FormLabel className="form-label">{email}<StarEle /></FormLabel>
                      <Input
                        className="form-control"
                        type="email"
                        name="email"
                        placeholder="Enter Email"
                        onChange={handleInputChange}
                        value={formData.email}
                      />
                      {emailError && (
                        <FormHelperText style={{ color: "red" }}>
                          {emailError}
                        </FormHelperText>
                      )}
                    </FormControl>
                    <FormControl className="mb-4">
                      <FormLabel className="form-label">{pass}<StarEle /></FormLabel>
                      <InputGroup>
                        <Input
                          placeholder="Enter Password"
                          className="form-control"
                          type={show ? "text" : "password"}
                          name="password"
                          onChange={handleInputChange}
                          value={formData.password}
                          endDecorator={
                            <IconButton
                              onClick={() => setShowPassword(!showPassword)}
                            >
                              {showPassword ? (
                                <ViewOffIcon
                                  style={{ fontSize: "var(--Icon-fontSize)" }}
                                  weight="bold"
                                />
                              ) : (
                                <ViewIcon
                                  style={{ fontSize: "var(--Icon-fontSize)" }}
                                  weight="bold"
                                />
                              )}
                            </IconButton>
                          }
                        />
                        <InputRightElement className="eye-btn-wrapper">
                          <Button
                            h="1.75rem"
                            size="sm"
                            onClick={handleClickPass}
                          >
                            {show ? <FaRegEye /> : <FaRegEyeSlash />}
                          </Button>
                        </InputRightElement>
                      </InputGroup>
                      {passwordError && (
                        <FormHelperText style={{ color: "red" }}>
                          {passwordError}
                        </FormHelperText>
                      )}
                    </FormControl>

                    <Button
                      fullwidth
                      type="submit"
                      className="dark-blue-btn mt-2"
                      fontSize={"16px !important"}
                      isDisabled={IsLoading}
                    >

                      Login
                    </Button>
                    <Box className="forgot-password-link">
                      <NextLink className="heading-color " href="/forgot-password">
                        Forgot password?
                      </NextLink>
                    </Box>
                    <Box className="create-account-link">
                      <Typography level="h3">
                        You didn't have account? -{" "}
                        <NextLink href="/signup" className="text-hover">
                          Create an account
                        </NextLink>
                      </Typography>
                    </Box>
                  </Stack>
                </Stack>
              </form>
            </Box>
            <Box className="login-form-img-wrapper">
              <Img src="/login-form-img.png" alt="login-img" />
            </Box>
          </Box>
        </Box>
      </Box>
    </Flex>
  );
};

export default Login;
